/**
 * FormValue
 * @class
 */
class FormValue {

  /**
   * @instance
   * @param _$el {HTMLElement}
   */
  constructor(_$el) {
    const $$items_ = _$el.querySelectorAll('input, select, textarea');

    this.itemElms = _.groupBy($$items_, (_$item) => {
      return _$item.getAttribute('name');
    });
  }

  /**
   * @instance
   */
  get() {
    const params = {}

    _.forEach(this.itemElms, (_$$el, _name) => {
      switch(_$$el[0].tagName) {
        case 'INPUT':
          switch(_$$el[0].type) {
            case 'text':
              params[_name] = _$$el[0].value;
              break;
            case 'radio':
              _.forEach(_$$el, (_$el) => {
                if(_$el.checked) {
                  params[_name] = _$el.value;
                  return;
                }
              });
              break;
            case 'checkbox':
              _.forEach(_$$el, (_$el, _i) => {
                params[`${_name}[${_i}]`] = _$el.checked ? 1 : 0;
              });
              break;
          }
          break;
        case 'SELECT':
          params[_name] = _$$el[0].value;
          break;
        case 'TEXTAREA':
          params[_name] = _$$el[0].value;
          break;
      }
    });

    return params;
  }


}

/**
 * class exports
 */
module.exports = FormValue;



/** WEBPACK FOOTER **
 ** ./webpack/requires/view/modules/form-value.js
 **/